/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacyBill from './pharmacy-bill';
import PharmacyBillDetail from './pharmacy-bill-detail';
import PharmacyBillUpdate from './pharmacy-bill-update';
import PharmacyBillDeleteDialog from './pharmacy-bill-delete-dialog';

const PharmacyBillRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacyBill />} />
    <Route path="new" element={<PharmacyBillUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacyBillDetail />} />
      <Route path="edit" element={<PharmacyBillUpdate />} />
      <Route path="delete" element={<PharmacyBillDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacyBillRoutes;
